<div class="container-fluid detail-modal-wrapper" [formGroup]="tableFormGroup">
    <div class="row">
        <div class="col detail-wrapper">
            <div class="input-field-wrapper">
                <div class="modal-header">
                    <div class="d-flex align-items-center">
                        <h4 class="mb-0 me-3">
                            {{ type == 'Edit' ? 'Edit - ' : '' }}
                            {{ type == 'Add' ? 'Add new entry to table ' : '' }}
                            {{ tableName }}
                        </h4>
                        <a href="javascript:void(0)" *ngIf="type == 'Details'" (click)="allItems()">Show all items</a>
                    </div>
                    <a class="close-icon" (click)="ngbActiveModal.close()"><i class="flaticon2-cross"></i></a>
                </div>
                <div class="my-5 px-5 custom_column" [ngClass]="{ column_1: column.length <= 7, column_2: column.length > 7 }">
                    <div class="label_Wrap" *ngFor="let item of data">
                        <div class="d-flex align-items-center label_info">
                            {{ item.key }}
                        </div>
                        <div class="d-flex align-items-center diagram-input-wrap">
                            <mat-form-field *ngIf="!(childColumns.includes(item.key) || parentColumns.includes(item.key))">
                                <input
                                    type="text"
                                    matInput
                                    [formControlName]="item.key"
                                    [class.highLight]="tableFormGroup.get(item.key).invalid && isSubmit && !tableFormGroup.get(item.key).disabled"
                                />
                            </mat-form-field>

                            <div class="d-flex align-items-center w-100" *ngIf="parentColumns.includes(item.key)">
                                <div *ngIf="type !== 'Details'" [floatLabel]="'never'" class="form-field-wrapper custom-field">
                                    <mat-select
                                        class="input-form-class select-form"
                                        panelClass="dropdown-wrapper"
                                        placeholder="Select"
                                        [formControlName]="item.key"
                                        [class.highLight]="tableFormGroup.get(item.key).invalid && isSubmit"
                                        (closed)="optionCloased(item)"
                                    >
                                        <div class="table-select-search-main">
                                            <div class="table-select-search">
                                                <input
                                                    class="form-input"
                                                    type="text"
                                                    name="Search"
                                                    required="required"
                                                    [(ngModel)]="item.searchKey"
                                                    (keyup)="searchResult($event, item)"
                                                    [ngModelOptions]="{ standalone: true }"
                                                />
                                                <label class="form-label" for="Search">Search</label>
                                            </div>
                                        </div>

                                        <mat-option class="option-list" *ngFor="let i of item.filterList" [value]="i.id">{{ i.value }}</mat-option>
                                    </mat-select>
                                </div>
                                <a href="javascript:void(0)" (click)="openParentDetails(item.key)" *ngIf="type === 'Details'">{{ rowData[item.key] }}</a>
                            </div>
                            <div class="d-flex align-items-center" *ngIf="childColumns.includes(item.key)">
                                <a href="javascript:void(0)" (click)="openChildDetails(item.key)"> {{ item.key }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer d-flex justify-content-between align-items-center">
                <button type="button" class="btn primary-ebtn" (click)="deleteDetails()" *ngIf="type === 'Details'">Delete</button>
                <div class="btn-wrap ms-auto">
                    <button type="button" class="btn secondary-ebtn" (click)="ngbActiveModal.close()">Cancel</button>
                    <button
                        type="button"
                        class="btn primary-ebtn"
                        (click)="openEdit()"
                        *ngIf="column.length !== childColumns.length + parentColumns.length + 1 && type === 'Details'"
                    >
                        Edit
                    </button>
                    <button
                        type="button"
                        class="btn primary-ebtn"
                        [disabled]="!tableFormGroup.dirty"
                        *ngIf="type === 'Edit'"
                        (click)="updateOrSaveTableDetails(true)"
                    >
                        Save
                    </button>
                    <button
                        type="button"
                        class="btn primary-ebtn"
                        [disabled]="!tableFormGroup.dirty"
                        *ngIf="type === 'Add'"
                        (click)="updateOrSaveTableDetails(false)"
                    >
                        Insert
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
